import useAnalyticsStore from '../stores/useAnalyticsStore/useAnalyticsStore'
import { useAnalyticsFiltersSaveParams } from './useAnalyticsFiltersSaveParams'

export const useBenchmarkingFiltersSaveParams = () => {
    const analyticsFiltersParams = useAnalyticsFiltersSaveParams()

    const benchmarkingSettings = useAnalyticsStore(
        (state) => state.benchmarking.reportSettings
    )

    const benchmarkingSettingsParams = {
        type: benchmarkingSettings.display,
        trendType: benchmarkingSettings.analysisType,
        comparisonPeriod:
            benchmarkingSettings.analysisType !== 'trend'
                ? benchmarkingSettings.comparisonPeriod
                : undefined,
        applyWeatherNormalization:
            benchmarkingSettings.applyWeatherNormalization,
        applySquareFootage: benchmarkingSettings.applySquareFootage,
        includeEmissions: benchmarkingSettings.basis === 'emission',
    }

    const params = {
        ...analyticsFiltersParams,
        ...benchmarkingSettingsParams,
    }

    return params
}
